export default __webpack_public_path__ + "static/media/4.1c64837a.jpg";